export const UserAreaWrapper = `flex flex-col justify-center items-center h-full py-10 gap-5`
export const UserAreaInfo = `flex gap-4 self-start`
